module.exports = __webpack_public_path__ + "static/media/ic-plus-gray-40.01e7f8de.svg";